import {
  CheckCircleIcon,
  QuestionMarkCircleIcon,
  XCircleIcon,
} from "@heroicons/react/24/outline";
import classNames from "classnames";
import CiroTooltipContainer from "../shared/CiroTooltipContainer";
import CiroPill from "../shared/CiroPill";
import CiroLink from "../shared/CiroLink";
import { CiroTableCellAlignEnum } from "../shared/CiroTable/CiroTableCell";
import CiroTableCell from "../shared/CiroTable/CiroTableCell";
import { useContext } from "react";
import NavigationContext from "../../contexts/NavigationContext";
import { getDomainFromUrl } from "../../utils/formatters";
import CiroSpinner from "../shared/CiroSpinner";

const AutopilotScoringResultTableCell = ({
  result,
  isLast,
  changeBreakpointOnNavCollapse = true,
  loading = false,
}: {
  result?: {
    criterion_fit?: boolean | null;
    reasoning?: string | null;
    sources?: string[] | null;
  };
  isLast: boolean;
  changeBreakpointOnNavCollapse?: boolean;
  loading?: boolean;
}) => {
  const { isNavCollapsed } = useContext(NavigationContext);
  const breakpointClass =
    changeBreakpointOnNavCollapse && !isNavCollapsed
      ? "max-2xl:hidden"
      : "max-xl:hidden";

  return (
    <CiroTableCell
      align={CiroTableCellAlignEnum.CENTER}
      isLastRow={isLast}
      className={classNames(breakpointClass)}
    >
      <CiroTooltipContainer
        tooltip={
          loading ? (
            <div
              className={classNames("flex", "items-center", "justify-center")}
            >
              <CiroSpinner loading />
            </div>
          ) : result?.reasoning || result?.sources?.length ? (
            <div className={classNames("flex", "flex-col", "gap-2")}>
              {result?.reasoning && <div>{result.reasoning}</div>}
              {result?.sources && result.sources.length > 0 && (
                <div
                  className={classNames(
                    "flex",
                    "flex-col",
                    "gap-2",
                    "mt-2",
                    "pt-2",
                    "border-t",
                    "border-gray-200",
                  )}
                >
                  <div className={classNames("flex", "flex-wrap", "gap-1")}>
                    {result.sources.map((source) => (
                      <CiroLink
                        key={source}
                        href={source}
                        shouldOpenInNewTab={true}
                        unstyled={true}
                      >
                        <CiroPill
                          background="bg-gray-100"
                          fontColor="text-gray-600"
                          customFontWeight="font-normal"
                        >
                          {getDomainFromUrl(source)}
                        </CiroPill>
                      </CiroLink>
                    ))}
                  </div>
                </div>
              )}
            </div>
          ) : undefined
        }
      >
        <div className={classNames("flex", "items-center", "justify-center")}>
          {result?.criterion_fit && (
            <CheckCircleIcon
              className={classNames("w-6", "h-6", "text-orange-400")}
            />
          )}
          {result?.criterion_fit === false && (
            <XCircleIcon
              className={classNames("w-6", "h-6", "text-gray-400")}
            />
          )}
          {result?.criterion_fit !== true &&
            result?.criterion_fit !== false && (
              <QuestionMarkCircleIcon
                className={classNames("w-6", "h-6", "text-gray-400")}
              />
            )}
        </div>
      </CiroTooltipContainer>
    </CiroTableCell>
  );
};

export default AutopilotScoringResultTableCell;
